import { Circle, type GetProps, styled, Theme } from "tamagui";
export type Status = "neutral" | "positive" | "negative" | "warning";
const pipVariants = {
  status: {
    positive: {
      backgroundColor: "$alertPositiveDark"
    },
    negative: {
      backgroundColor: "$alertNegative"
    },
    warning: {
      backgroundColor: "$alertWarning"
    },
    neutral: {
      backgroundColor: "$textPrimary"
    }
  }
} as const;
const StyledPip = styled(Circle, {
  name: "Pip",
  tag: "span",
  role: "status",
  variants: pipVariants,
  width: "$0.75",
  height: "$0.75",
  defaultVariants: {
    status: "neutral"
  }
});
type StyledPipProps = GetProps<typeof StyledPip>;
export type PipProps = StyledPipProps & {
  status?: Status;
};
export const Pip = (props: PipProps) => {
  const {
    status = "neutral",
    ...rest
  } = props;
  return <Theme name="v2" data-sentry-element="Theme" data-sentry-component="Pip" data-sentry-source-file="Pip.tsx">
      <StyledPip {...rest} status={status} data-sentry-element="StyledPip" data-sentry-source-file="Pip.tsx" />
    </Theme>;
};